import { combineReducers } from 'redux';
import UserReducer from './reducer_user';
import ActivitiesReducer from './reducer_activity';
import DepartmentsReducer from './reducer_department';
import DependencyReducer from './reducer_dependency';
import Deliverable from './reducer_deliverable';
import currentUser from './reducer_currentuser';
import Objective from './reducer_objective';
import Update from './reducer_update';

const rootReducer = combineReducers({
    deliverables: Deliverable,
    last_updated: Update,
    objectives: Objective,
    currentUser: currentUser,
    users: UserReducer,
    activities: ActivitiesReducer,
    departments: DepartmentsReducer,
    dependencies: DependencyReducer
});

export default rootReducer;